import { NGXAjax } from '../../common/Services/AjaxService.js';
import RefData from 'ref-data';

/**
 * Fetches the list of rewards
 * @param {*} containerRef - container ref to fetch rewards for
 * @param {*} subtypeRef - subtype of rewards to fetch
 */
function fetchRewards(containerRef, subtypeRef = RefData.Enum.TYPE.CAMPAIGNPROMOTION.REWARD) {
  return NGXAjax.get('/api/reward/list.json', {
    containerRef,
    subtypeRef,
  })
    .then(response => response.data.content)
    .catch(error => ({error}));
}

export { fetchRewards };
